// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"52560415","235":"09310b08","433":"d8919ca0","527":"901378ba","597":"c0b2af64","660":"d18ba1a7","689":"1625bdad","774":"4586e055","787":"fcb6a2f9","793":"fa68d5c6","796":"ff1e5d64","797":"af840850","838":"1a9d881d","841":"bd4132b8","992":"b1b2ca0e"}[chunkId] + ".chunk.js";
};